import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// The candidate build (candidate.bsgtraders.uk, paper only) is marked on every page so it can't be
// mistaken for LIVE. Set at build time: REACT_APP_INSTANCE=candidate.
const isCandidate = process.env.REACT_APP_INSTANCE === 'candidate';
if (isCandidate) document.title = `[CANDIDATE] ${document.title}`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isCandidate && (
      <div style={{ position: 'sticky', top: 0, zIndex: 10000, background: '#b26a00', color: '#fff',
                    textAlign: 'center', fontSize: 12, fontWeight: 600, padding: '3px 8px' }}>
        CANDIDATE — paper only, not the live engine
      </div>
    )}
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
